export { r as rubberbandIfOutOfBounds } from '../../dist/maths-b28d9b98.esm.js';
